import React from 'react'

const TextInput = React.forwardRef((props, ref) => (
  <label className='league-label'>
    {props.label}
    <input className='league-control' {...props} ref={ref} />
    {props.error && <div className='error_container'>{props.error.message}</div>}
  </label>
))

export default TextInput
